module.exports = __webpack_public_path__ + "static/logo-on-text-d7f3bc2ba3b9bc413aa6997465c6c4da.svg";